import { createFileRoute } from "@tanstack/react-router";

import { JobsPage } from "../../../../areas/admin/jobs/JobsPage";
import { LeadsUsageCard } from "../../../../areas/admin/leads/LeadsUsageCard";

export const Route = createFileRoute("/app/_seller/admin/jobs")({
  component: AdminJobs,
});

function AdminJobs() {
  return (
    <>
      <JobsPage />
      {/* FE-18 FR-FE18-20: lead dossier usage next to the failed jobs. */}
      <div className="mx-auto w-full max-w-[720px] px-4 pb-6">
        <LeadsUsageCard />
      </div>
    </>
  );
}
